// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Policies Module

// Fetch the application policies from the Server as guidance

define('Policies',['require','ReturnCodes','Server','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        ReturnCodes = require('ReturnCodes'),
        Server = require('Server'),
        Utilities = require('Utilities'),

        self,
        returnCodes,
        server,
        utilities,
        appPolicies = {};  // Map of application policies


    // Constructor
    function Policies () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

        // Get server instance
        returnCodes = new ReturnCodes();
        server = new Server();
        utilities = new Utilities();
    };

    // Public Prototype Methods

    // Get the current Policies
    Policies.prototype.getPolicies = function(callback) {
        // Add standard headers
        var requestData = {};
        requestData['v'] = utilities.getApiVersion();
        requestData['command'] = utilities.getCommandCode('getPolicies');
        requestData['deviceId'] = utilities.getDeviceId();

        // Submit
        var timeout = 15000;
        server.submit(requestData, timeout, function (response) {
            // Check the response and take appropriate action
            if (response) {
                // Good response
                if (response.status == returnCodes.getCode('SUCCESS_RC')) {
                    // Return policies to caller
                    appPolicies = response.policies;
                    if (callback) {
                        callback(response);
                    }
                // Timeout
                } else if (response.timeout) {
                    // Try to continue with an empty list
                    if (callback) {
                        response.policies = {};
                        callback(response);
                    }
                // Something bad happened
                } else {
                    if (callback) {
                        response.policies = {};
                        callback(response);
                    }
                }
            }
        }.bind(this));
    };

    // Update server Policies (requires admin privs)
    Policies.prototype.updatePolicies = function(newPolicies, callback) {
        // Add standard headers
        var requestData = {};
        requestData['v'] = utilities.getApiVersion();
        requestData['command'] = utilities.getCommandCode('updatePolicies');
        requestData['deviceId'] = utilities.getDeviceId();
        requestData['policies'] = newPolicies;
        // Submit
        var timeout = 15000;
        server.submit(requestData, timeout, function (response) {
            // Check the response and take appropriate action
            if (response) {
                // Good response
                if (response.status == returnCodes.getCode('SUCCESS_RC')) {
                    if (callback) {
                        callback(response);
                    }
                // Timeout
                } else if (response.timeout) {
                    // Try to continue with an empty list
                    if (callback) {
                        callback(response);
                    }
                // Something bad happened
                } else {
                    console.log(response);
                    if (response.communication) {
                        utilities.showAlert('ERROR: ' + response.communication);
                    }
                    if (callback) {
                        callback(response);
                    }
                }
            }
        });
    };

    // Get specified policy
    Policies.prototype.getPolicy = function (appPolicy) {
        return appPolicies[appPolicy];
    };

    // Set specified policy
    Policies.prototype.setPolicy = function (appPolicy, value) {
        appPolicies[appPolicy] = value;
    };

    // Return Constructor
    return Policies.prototype.constructor;
});

